// import {
//     Calendar
// } from "@fullcalendar/core";
// import interactionPlugin from "@fullcalendar/interaction";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import listPlugin from "@fullcalendar/list";
// import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
// import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";

// import {Draggable} from "fullcalendar-scheduler";

/**
 * 車両予約ページ用のスクリプト
 */
if (is_route('vehicle_reservation.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function () {
        vehicle_reservation_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.vehicle_reservation_event_set = function ()
{
    // ------------------------------
    // fullCalendar(配車板timeline)部制御
    // ------------------------------
    var timeline = {

        /*---- properties ----*/
        _calendarId: 'vehicle_reservation-calendar',    // 生成要素
        _calendar: {},                          // カレンダーobject
        _calendarEl: [],                        // カレンダー要素
        _currentDate: new Date().toISOString(),             // カレント日付
        _currentView: 'resourceTimelineDay',    // カレントVIEW
        _external: null,                        // 外部ドラッグイベントobject
        _scrollX: -1,                           // スクロール位置横
        _scrollY: -1,                           // スクロール位置縦
        _initOptions: {                         // calendar Option
            slotMinWidth: 10,
            eventMinWidth: 10,
            editable: true,
            selectable: true,
            nowIndicator: true,
            initialView: 'resourceTimelineDay',
            initialDate: new Date().toISOString(),
            views: {
                resourceTimelineDay: {
                    resourceAreaWidth: "12%",
                    slotDuration: '00:30:00',
                },
                resourceTimelineWeek: {
                    slotLabelInterval: {hours: 6},
                    slotDuration: '2:00:00',
                    resourceAreaWidth: "12%",
                    slotMinWidth: 13,
                    eventMinWidth: 2,
                },
            },
            headerToolbar: {
                left: 'prev,today,next',
                center: 'title',
                right: 'resourceTimelineDay,resourceTimelineWeek',
            },
        },

        /*---- カレンダー生成 ----*/
        setCalender: function() {
            // set selector
            timeline._calendarEl = $('#' + timeline._calendarId);
            // escape when not selector
            if (timeline._calendarEl.length === 0) {
                return;
            }
            // init option
            timeline._initOptions.initialView = timeline._currentView;
            timeline._initOptions.initialDate = timeline._currentDate;

            // create fullCalendar object
            timeline._calendar = fullCalendar(timeline._calendarId,
                extend_url_query(timeline._calendarEl.data('resource')),    // resourceURL
                extend_url_query(timeline._calendarEl.data('event')),       // eventURL
                timeline._calendarEl.data('content_header'),                // resourceHeaderText
                timeline._initOptions
            );

            // set option
            timeline.setOption();

            // rendering
            timeline._calendar.render();
        },

        /*---- set option ----*/
        setOption: function() {
            // let externalEl = $('#external-draggable');  // 外部ドラッグ対象リスト

            /* setting draggable(リソースをまたいでの制御は、eventデータのconstrainで指定) */
            // 乗務員：同一会社所属、車両：同一会社所属リソースに対してdraggable=trueとなる
            timeline._calendar.setOption('eventResourceEditable', true);

            /* view */
            /* keep scroll position */
            timeline._calendar.setOption('scrollTimeReset', false);
            timeline._calendar.setOption('viewDidMount', function (view) {
                if(timeline._scrollX >= 0 || timeline._scrollY >= 0) {
                    setTimeout(function () {
                        document.querySelector('.fc-timeline-header').parentNode.scrollLeft = timeline._scrollX;
                        document.querySelector('.fc-timeline-slots').parentNode.parentNode.scrollTo(timeline._scrollX, timeline._scrollY);
                    }, 300);
                }
            });

            /* group by section_id when not alone */
            if (!timeline._calendarEl.data('is_one_section')) {
                // every section_id
                timeline._calendar.setOption('resourceGroupField', 'section_id');
                // edit section label
                timeline._calendar.setOption('resourceGroupLabelContent', function (arg) {
                    let arr = Object.values(timeline._calendar.currentData.resourceStore);
                    let result = arr.filter(function (resource) {
                        return arg.groupValue === resource.extendedProps.section_id;
                    });
                    let groupName = result.length > 0 ? result[0].extendedProps.section_name : '';
                    return {html: `<strong>${groupName}</strong> `};
                });
            }

            /* control event */
            // initial popover
            timeline._calendar.setOption('eventDidMount', function (eventObj) {
                // 静止状態で初期化
                if (eventObj.isEnd && (!eventObj.isDragging && !eventObj.isResizing)) {
                    $(eventObj.el).popover({
                        content: eventObj.event.extendedProps.description,
                        trigger: 'hover',
                        placement: 'auto',
                        container: 'body',
                        html: true
                    });
                }
            });
            // escape when not editable
            if (!timeline._initOptions.editable) {
                return;
            }
            // select
            timeline._calendar.setOption('select', function (eventObj) {
                // close popover
                $(eventObj.el).popover('hide');
                // open setting modal
                let data = {
                    id: null,
                    // resource_id: eventObj.resource._resource.id,
                    start: eventObj.startStr,
                    end: eventObj.endStr,
                    user_id: (eventObj.resource) ? eventObj.resource._resource.id : null,
                    user_name: (eventObj.resource) ? eventObj.resource._resource.title : null,
                    vehicle_id: (eventObj.resource) ? eventObj.resource._resource.id : null,
                    vehicle_name: (eventObj.resource) ? eventObj.resource._resource.title : null,
                    section_id: (eventObj.resource) ? eventObj.resource._resource.extendedProps.section_id : null,
                    section_name: (eventObj.resource) ? eventObj.resource._resource.extendedProps.section_name : null,
                };
                timeline.openModal(eventObj, data);
            });
            // click event data
            timeline._calendar.setOption('eventClick', function (eventObj) {
                // close popover
                $(eventObj.el).popover('hide');
                // open setting modal
                let data = {
                    id: eventObj.event.id,
                };
                timeline.openModal(eventObj, data);
            });
            // drop event data
            timeline._calendar.setOption('eventDrop', function (eventObj) {
                let data = null;
                if(eventObj.newResource) {
                    // リソースの変更があった場合
                    // ex) 社員タブの場合、社員が変わった際の処理
                    data = {
                        id: eventObj.event.id,
                        start: eventObj.event.startStr,
                        end: eventObj.event.endStr,
                        user_id: (eventObj.newResource) ? eventObj.newResource._resource.id : null,
                        user_name: (eventObj.newResource) ? eventObj.newResource._resource.title : null,
                        section_id: (eventObj.newResource) ? eventObj.newResource._resource.extendedProps.section_id : null,
                        section_name: (eventObj.newResource) ? eventObj.newResource._resource.extendedProps.section_name : null,
                        vehicle_id: (eventObj.newResource) ? eventObj.newResource._resource.id : null,
                        vehicle_name: (eventObj.newResource) ? eventObj.newResource._resource.title : null,
                        is_drop: true
                    };
                    if (eventObj.event.extendedProps.vehicle_id) {
                        data.vehicle_id = eventObj.event._def.resourceIds[0];
                    }
                } else {
                    // リソースの変更がない場合
                    // ex) 社員タブの場合、社員が変わらず日時のみの変更時の処理
                    data = {
                        id: eventObj.event.id,
                        start: eventObj.event.startStr,
                        end: eventObj.event.endStr,
                        user_id: (eventObj.oldEvent) ? eventObj.oldEvent._def.resourceIds[0] : null,
                        user_name: (eventObj.oldEvent) ? eventObj.oldEvent._def.title : null,
                        section_id: (eventObj.oldEvent) ? eventObj.oldEvent._def.extendedProps.section_id : null,
                        section_name: (eventObj.oldEvent) ? eventObj.oldEvent._def.extendedProps.section_name : null,
                        vehicle_id: (eventObj.oldEvent) ? eventObj.oldEvent._def.resourceIds[0] : null,
                        vehicle_name: (eventObj.oldEvent) ? eventObj.oldEvent._def.title : null,
                        is_drop: true
                    };
                    if (eventObj.event.extendedProps.vehicle_id) {
                        data.vehicle_id = eventObj.event._def.resourceIds[0];
                    }
                }
                timeline.openModal(eventObj, data);
            });
            // resize start event data
            timeline._calendar.setOption('eventResizeStart', function (eventObj) {
                $('div.popover').hide();
                $(eventObj.el).popover('disable');
            });
            // resize stop event data
            timeline._calendar.setOption('eventResizeStop', function (eventObj) {
                $(eventObj.el).popover('update');
            });
            // resize event data
            timeline._calendar.setOption('eventResize', function (eventObj) {
                let data = {
                    id: eventObj.event.id,
                    start: eventObj.event.startStr,
                    end: eventObj.event.endStr,
                };
                if (eventObj.event.extendedProps.hasOwnProperty('user_id')) {
                    data.user_id = eventObj.event._def.resourceIds[0];
                }
                if (eventObj.event.extendedProps.hasOwnProperty('vehicle_id')) {
                    data.vehicle_id = eventObj.event._def.resourceIds[0];
                }
                timeline.openModal(eventObj, data);
            });
        },

        /*---- カレント情報更新 ----*/
        currentInfo: function() {
            if (timeline._calendar.hasOwnProperty('isRendered')) {
                let inputStart = new Date().toISOString();
                if (document.querySelector("input[name=started_at]").value) {
                    inputStart = new Date(document.querySelector("input[name=started_at]").value);
                }
                timeline._currentDate = inputStart;
                timeline._currentView = timeline._calendar.view.type;
                if ($('.fc-timeline-slots').length > 0) {
                    timeline._scrollX = document.querySelector('.fc-timeline-slots').parentNode.parentNode.scrollLeft;
                    timeline._scrollY = document.querySelector('.fc-timeline-slots').parentNode.parentNode.scrollTop;
                }
            }
        },

        /*---- モーダル表示 ----*/
        openModal: function(eventObj, data) {
            $('div.popover').hide();
            $(eventObj.el).popover('enable');
            let action = extend_url_query(timeline._calendarEl.data('action'));
            let modalId = timeline._calendarEl.data('modal');
            let submit = timeline._calendarEl.data('submit');
            // モーダルのコンテンツを空に
            $('#' + modalId + ' .modal-content').empty();
            // 送信
            _ajax.post(action, data, function (results) {
                $('#' + modalId + ' .modal-content').html(results);
                initialize();
                _modal.show('#' + modalId);
                // // 未割当リストの表示状態を保持しておく
                // $('[' + submit + ']').data('drawer_open', $('#drawer-content').is(':visible'));
            }, function (xhr, status, errorThrown) {
                _error.omitted(xhr, status, errorThrown);
            }, 'html');
        },
    }

    // KEYWORD検索フォーム初期化
    if ($("#resourceTimelineDay-calendar").length === 0) {
        $('.navbar-search-block').removeClass('d-none');
    } else {
        $('#toolbar-keyword-search').val('');
        $('.navbar-search-block').addClass('d-none');
    }

    // load_contents--カレンダー再描画処理のため、共通の検索用イベントをOFF
    $(document).off('change', '#search-form, #toolbar-keyword-search');
    $(document).off('click', '#toolbar-keyword-search-submit, #toolbar-keyword-search-reset');

    // イベント再登録(callbackにsetCalendar処理をCALLする)
    $(document).on('change', '#search-form, #toolbar-keyword-search', function () {
        // let open = $('#drawer-content').is(':visible');
        timeline.currentInfo();
        // コンテンツを読込
        load_contents(function () {
            timeline.setCalender();
            // drawer.toggle(open);
            setTimeout(function () {
                if ($("#resourceTimelineDay-calendar").length === 0) {
                    $('.navbar-search-block').removeClass('d-none');
                } else {
                    $('.navbar-search-block').addClass('d-none');
                }
            }, 10);
        }, false);
    });

    $(document).on('click', '#toolbar-keyword-search-submit, #toolbar-keyword-search-reset', function () {
        // let open = $('#drawer-content').is(':visible');
        timeline.currentInfo();
        // コンテンツを読込
        load_contents(function () {
            timeline.setCalender();
            // drawer.toggle(open);
        }, false);
    });

    // グループ会社変更時
    $(document).on('change', '#search-form-holding_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('company_id', 'section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'holding_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 会社変更時
    $(document).on('change', '#search-form-company_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'company_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 営業所変更時
    $(document).on('change', '#search-form-section_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            let urlString = new URL(location.href);
            urlString.searchParams.delete('section_id');
            location.href = urlString;
            return false;
        }
        let excutionData = [];
        excutionData.push('section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'section_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });
    


    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        timeline.currentInfo();
        _modal.submit(this, 'save-modal', function(results) {
            // カレンダー更新
            timeline.setCalender();
        }, function() {
            // vehicle_set_steper_error();
        });
    });

    // 設定保存キャンセル時
    $(document).on('click', '[data-dismiss]', function () {
        timeline.setCalender();
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            // カレンダー更新
            timeline.setCalender();
        });
    });

    // load
    $('#search-form').trigger('change');
    
}
